interface SubMsg {
  code: string
  note: string
}

interface ServerErrorParams {
  resultCode: string
  errMsg: SubMsg
}

export class ServerError {
  public code: string
  public subMsg: SubMsg

  constructor(props: ServerErrorParams) {
    this.code = props.resultCode
    this.subMsg = props.errMsg
  }

  get bCode() {
    return this.subMsg.code || ''
  }

  get bMsg() {
    return this.subMsg.note || ''
  }

  get msgIsObject() {
    return this.subMsg?.note?.indexOf('title') !== -1
  }

  get content() {
    if (this.msgIsObject) {
      const msg = JSON.parse(this.subMsg.note)
      return `${msg.content}（${this.bCode}）`
    } else {
      return `${this.bMsg}（${this.bCode}）`
    }
  }

  get title() {
    if (!this.msgIsObject) {
      return ''
    }
    const msg = JSON.parse(this.subMsg.note)
    return msg.title
  }
}
